import styles from './styles.module.scss'
import React from "react";
import {useFormikContext} from "formik";

const FormInputError = ({name, style}) => {
    const { errors } = useFormikContext();
    return (errors[name]) ? <div style={style} className={styles.error}>{errors[name]}</div> : null;
}

export default FormInputError;